import LoansToCover from './LoansToCover'

export default LoansToCover
